export default {
    report: 'Report',
    dailyReport: 'Daily Report',
    monthlyReport: 'Monthly Report',
    empMonthlyLogReport: 'Employee Monthly Log Report',
    monthlyRecordingReport: 'Monthly Recording Report',
    allBranch: 'All Branch',
    attendanceReport: 'Attendance',
    visitorReport: 'Visitor activity',
    forgotCheckDailyReport: 'Forgot Check-In Daily Report'
}
